import type { SelfServiceAPI } from 'types';
import type { Options } from '../types';
import api from 'lib/axios/api';
import handleServiceError from '../utils/handleServiceError';

const createCancellation = async (bookingId: string, options: Options = {}): Promise<SelfServiceAPI.CreateCancellation.Response> => {
  try {
    const { data } = await api.post(`/bookings/${bookingId}/cancellations`);
    return data;
  } catch (error) {
    handleServiceError(error, {
      operationName: `POST /bookings/${bookingId}/cancellations`,
      skipUnauthenticatedRedirection: options.skipUnauthenticatedRedirection,
    });

    return new Promise(() => {});
  }
};

export default createCancellation;
